export default {"src":"/_next/static/media/filter.1a2f53fd.svg","height":18,"width":17};